import styled from "styled-components";
import { BORDER_RADIUS, COLORS, FONT_FAMILY, FONT_WEIGHT } from "constants/variables";
import cursorIcon from "assets/img/Cursor.png";

export const ResourceBanner = styled.a<{ $biggerCursor: boolean }>`
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 40px;
  width: calc(100% - 48px);
  max-width: 1464px;
  margin: 0 auto 40px;
  padding: 32px 40px;
  border-radius: ${BORDER_RADIUS.radius24};
  background: ${COLORS.FaluRed};
  color: ${COLORS.Cultured};
  text-decoration: none;
  cursor: ${({ $biggerCursor }) => $biggerCursor ? `url(${cursorIcon}), auto` : "pointer"};
  transition: background-color 160ms ease-out;
  &:hover { background: ${COLORS.VividAuburn}; }
  &:focus-visible { outline: 3px solid ${COLORS.Crimson}; outline-offset: 4px; }
  @media (max-width: 900px) {
    grid-template-columns: minmax(0, 1fr);
    gap: 24px;
    padding: 28px 32px;
  }
  @media (max-width: 767px) {
    padding: 24px;
    margin-bottom: 24px;
  }
  @media (prefers-reduced-motion: reduce) { transition: none; }
`;

export const ResourceCopy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 960px;
  min-width: 0;
`;

export const ResourceSource = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: ${COLORS.Yellow};
  > svg { flex-shrink: 0; }
`;

export const ResourceAction = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 48px;
  padding: 12px 20px;
  border-radius: ${BORDER_RADIUS.radius24};
  background: ${COLORS.Yellow};
  color: ${COLORS.RaisinBlack};
  font-family: ${FONT_FAMILY.poppins};
  font-size: 14px;
  font-weight: ${FONT_WEIGHT.semiBold};
  white-space: nowrap;
  > svg { flex-shrink: 0; }
  @media (max-width: 900px) { justify-self: start; }
  @media (max-width: 767px) { width: 100%; white-space: normal; padding: 12px 16px; }
`;
